const PropTypes = require('prop-types');
const React = require('react');
const PriceFieldWithCurrency = require('components/shared/price_field_with_currency');

const EVERYWHERE_ELSE_CODE = 'XX';

class ShippingRate extends React.Component {
  constructor(props) {
    super(props);

    this.onRemoveShippingRate = this.onRemoveShippingRate.bind(this);
  }

  onRemoveShippingRate() {
    this.props.onRemoveShippingRate(this.props.shippingRate);
  }

  renderShippingRegionName() {
    if (this.props.shippingRate.regionCode === EVERYWHERE_ELSE_CODE) {
      return <span>{I18n.t('shippingRates.everywhereElse')}</span>;
    }

    return <span>{this.props.shippingRate.regionName}</span>;
  }

  renderRequireFlag() {
    if (!this.props.shippingRate.isRequired) { return null; }

    return (
      <span className="opacity-70 d-block">
        {I18n.t('shippingRates.rateFields.required')}
      </span>
    );
  }

  renderRemove() {
    if (this.props.shippingRate.isRequired) return null;

    return (
      <button
        className="fa fa-remove button-as-link"
        onClick={this.onRemoveShippingRate}
      />
    );
  }

  renderBaseRateField() {
    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.standardRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.rate.currency}
          required
          name={`${this.props.fieldsPrefix}[shipping][rates][][rate]`}
          defaultValue={this.props.shippingRate.rate.amount}
        />
      </div>
    );
  }

  renderExpeditedRateField() {
    if (!this.props.showExpeditedFields) {
      return null;
    }

    if (!this.props.shippingRate.isRequired) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.expeditedRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.expeditedRate.currency}
          required
          name={`${this.props.fieldsPrefix}[shipping][rates][][expedited_rate]`}
          defaultValue={this.props.shippingRate.expeditedRate.amount}
        />
      </div>
    );
  }

  renderIncrementalRateField() {
    if (!this.props.showIncrementalFields) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.incrementalRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.incrementalRate.currency}
          required
          name={`${this.props.fieldsPrefix}[shipping][rates][][incremental_rate]`}
          defaultValue={this.props.shippingRate.incrementalRate.amount}
        />
      </div>
    );
  }

  renderFreeShippingThresholdField() {
    if (!this.props.showFreeShippingThresholdFields) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.freeShippingThreshold')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.freeShippingThreshold.currency}
          name={`${this.props.fieldsPrefix}[shipping][rates][][free_shipping_threshold]`}
          defaultValue={this.props.shippingRate.freeShippingThreshold.amount}
        />
      </div>
    );
  }

  render() {
    return (
      <tr>
        <td>
          {this.renderShippingRegionName()}
        </td>
        <td>
          <input
            type="hidden"
            name={`${this.props.fieldsPrefix}[shipping][rates][][region_type]`}
            value={this.props.shippingRate.regionType}
          />
          <input
            type="hidden"
            name={`${this.props.fieldsPrefix}[shipping][rates][][region_code]`}
            value={this.props.shippingRate.regionCode}
          />
          {this.renderBaseRateField()}
          {this.renderExpeditedRateField()}
          {this.renderIncrementalRateField()}
          {this.renderFreeShippingThresholdField()}
        </td>
        <td className="shipping-rate-action center" data-remove-rate>
          {this.renderRemove()}
        </td>
      </tr>
    );
  }
}

ShippingRate.propTypes = {
  fieldsPrefix: PropTypes.string.isRequired,
  showExpeditedFields: PropTypes.bool.isRequired,
  showIncrementalFields: PropTypes.bool.isRequired,
  showFreeShippingThresholdFields: PropTypes.bool.isRequired,
  shippingRate: PropTypes.object,
  onRemoveShippingRate: PropTypes.func.isRequired,
};

module.exports = ShippingRate;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_rates/shipping_rate.jsx